import React, {useEffect, useState, useRef, Fragment} from 'react';
import {Spinner} from "react-bootstrap";
import {connect} from "react-redux";


const GeoDataFicheProprietaire = (props) => {

    const [isLoading, setIsLoading] = useState(false)
    const [asData, setAsData]       = useState(false)
    const [items, setItems] = useState([])
    const [isCollectivitite, setIsCollectivite] = useState(false)


    useEffect(()=>{
        if(props.currentEntity && props.currentEntity.genre && props.currentEntity.genre.slug == 'collective'){
            setIsCollectivite(true);
            fetchData()
        }else{
            setAsData(true)
            setIsLoading(false)
            setItems(['vide'])
        }

    },[props.keypars])

    useEffect(()=>{
        (items.length>0)?setAsData(true):setAsData(false)
    }, [items])

    const fetchData=()=>{

            setIsLoading(true)
            const params = {
                'key_parcelles' : props.keypars
            }
            axios.post('/Api/geodata/stat/parcelle/proprietaire', params)
                .then(result=>{
                    setItems(result.data);
                    props.updateFormData('proprietaire', result.data)
                    setIsLoading(false)
                }).catch(err => {
                    console.log(err);
                    props.updateFormData('proprietaire', [])
                })
    }


    const  stringToLowerCase=(str)=>{
        return str.split(' ').map(item =>
            item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()).join(' ');
    }

    const renderItem=(item, index)=>{
       return(
           <tr key={index}>
              <td className="refDnuproSearch" id={item.dnupro}>{item.l_ccodro}</td>
              <td>{item.ddenom}</td>
              <td>{stringToLowerCase(item.dlign3) } {stringToLowerCase(item.dlign4)} {item.dlign6}</td>
           </tr>

       );
    }

    return (
        <Fragment>
        {/*
        <div id={'geodata_propietaire'} style={{"marginTop": "10px", "marginBottom":"15px"}} className={(asData)?"ueGeoDataSubpanel":null}>
            {
                (asData)
                    ?<Fragment>
                        <div className={'ue-geodata-section-title'}>Propriétaire :</div>
                        <table className="table table-condensed ue-table-data"
                               style={{"width": "100%", "fontSize": "0.57rem"}}>
                            <thead>
                                <tr>
                                    <th width="10%">Droit</th><th width="30%">Nom</th><th width="60%">Adresse</th>
                                </tr>
                            </thead>
                            <tbody>
                            {   (isCollectivitite)
                                    ?(isLoading)
                                        ?<tr><td colSpan={'8'} className="text-center"><Spinner animation="border" size={'sm'} /></td></tr>
                                        :<Fragment>
                                            {
                                                items.map((item, index) => renderItem(item, index) )
                                            }
                                        </Fragment>
                                    :<tr><td colSpan={'8'} className="text-center">
                                    <div className={'border border-light rounded p-2 text-light'} style={{"fontSize": "0.8rem", "backgroundColor":"#a0b1bf"}}>
                                        <i className="fas fa-eye-slash"></i> Données propriétaires réservées aux collectivités
                                    </div></td></tr>
                            }
                            </tbody>
                        </table>
                    </Fragment>
                    :(isLoading)?<div className="text-center my-2"><Spinner animation="border" size={'sm'}/></div>:<div></div>
            }
        </div>
        */}
        </Fragment>
    );
};

const mapStateToProps = state => {
    return {
        currentEntity: state.MeReducer.entity,
        userSubscription : state.MeReducer.subscription,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        updateFormData: (k, e)=> dispatch( {type: 'UPDATE_FORM_DATA', data:{key : k, data: e}}),
    }
}
export default connect(mapStateToProps, mapDispatchTProps)(GeoDataFicheProprietaire);

